import React from "react";
import { Box, Button, CircularProgress, Tooltip, Typography } from "@mui/material";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import SendIcon from "@mui/icons-material/Send";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { ArrowBack, AssuredWorkload, CalendarMonthOutlined, FactCheckOutlined } from "@mui/icons-material";
import { isInviteListValid, isRunValidationInviteListValid } from "../services/inviteUserService";

const InviteUserTableTopToolbar = ({
  showInviteTable,
  setShowInviteTable,
  setSelectedRowData,
  setActiveModal,
  addNewInviteRow,
  inviteList,
  runValidation,
  isValidationPending,
  userValidationData
}) => {
  
  const handleBackToSessionList = () => {
    setSelectedRowData(null);
    setShowInviteTable(false);
  };
  return (
    <Box
      sx={{
        display: "flex",
        gap: "16px",
        padding: "8px",
        alignItems: "center",
      }}
    >
      <Typography sx={{ fontSize: "16px", color: "#626262" }}>Invite List</Typography>

      {showInviteTable && (
        <Button
          startIcon={<ArrowBack />}
          variant="contained"
          onClick={handleBackToSessionList}
        >
          Back to Session List
        </Button>
      )}

      <Button
        size="small"
        variant="outlined"
        startIcon={<FileUploadIcon />}
        onClick={() => setActiveModal("bulkImport")}
      >
        Bulk Import
      </Button>

      <Button
        size="small"
        variant="outlined"
        startIcon={<PersonAddAltIcon />}
        onClick={addNewInviteRow}
      >
        Add User
      </Button>

      <Button
        size="small"
        variant="outlined"
        startIcon={<AssuredWorkload />}
        onClick={() => setActiveModal("addRole")}
      >
        Add Role
      </Button>

      <Button
        size="small"
        variant="outlined"
        startIcon={<ConfirmationNumberIcon />}
        onClick={() => setActiveModal("assignLicense")}
      >
        Assign Seat
      </Button>

      <Button
        size="small"
        variant="outlined"
        startIcon={<CalendarMonthOutlined />}
        onClick={() => setActiveModal("startDate")}
      >
        Start Date
      </Button>

      <Button
        size="small"
        variant="outlined"
        startIcon={!isValidationPending  ? <FactCheckOutlined />  : null}
        onClick={runValidation}
        disabled={isValidationPending || !isInviteListValid(inviteList)}
        endIcon={
          isValidationPending ? <CircularProgress size={15} color="primary" /> : null
        }
      >
        Run validation
      </Button>

      <Tooltip
        title={
          isInviteListValid(inviteList)
            ? ""
            : "Please fill out all fields for every user"
        }
      >
        <span>
          <Button
            size="small"
            variant="outlined"
            startIcon={<SendIcon />}
            onClick={() => setActiveModal("inviteUser")}
            disabled={!isInviteListValid(inviteList) || !isRunValidationInviteListValid(inviteList,userValidationData)}
          >
            Invite User
          </Button>
        </span>
      </Tooltip>

    </Box>
  );
};

export default InviteUserTableTopToolbar;